import type { MultiStepFormStep } from '#/components/Form/MultiStepForm/MultiStepFormTypes';

export function getAllFieldNamesFromSteps(
  steps: MultiStepFormStep[],
): Set<string> {
  const fieldNames = new Set<string>();
  for (const step of steps) {
    for (const section of step.sections) {
      for (const row of section.rows) {
        if (!row) continue;
        const fields = row.fieldsToValidate ?? row.fields;
        for (const field of fields) {
          fieldNames.add(field);
        }
      }
    }
  }
  return fieldNames;
}
